import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PuntiCampionamentoRoutingModule } from './punti-campionamento-routing.module';
import { PuntiCampionamentoService } from './punti-campionamento.service';
import { provideQueryService } from 'src/app/core/services/query.service';
import {  PUNTI_CAMPIONAMENTO_ENDPOINT, PUNTI_CAMPIONAMENTO_STORICO_ENDPOINT, puntiCampionamentoStateConfig } from './punti-campionamento.config';
import { IControlliEffettuati, IPuntoCampionamento } from './punti-campionamento.model';
import { ControlloDettaglioService } from './controllo-dettaglio.service';
import { CONTROLLO_DETTAGLIO_ENDPOINT, controlloDettaglioStateConfig } from './controlli-dettaglio.config';
import { PuntiCampionamentoStoricoService } from './punti-campionamento-storico.service';

@NgModule({
  declarations: [],
  providers: [
    ...provideQueryService<IPuntoCampionamento>(PUNTI_CAMPIONAMENTO_ENDPOINT, puntiCampionamentoStateConfig),
    PuntiCampionamentoService,
    ...provideQueryService<IControlliEffettuati>(CONTROLLO_DETTAGLIO_ENDPOINT, controlloDettaglioStateConfig),
    ControlloDettaglioService,
    ...provideQueryService<IPuntoCampionamento>(PUNTI_CAMPIONAMENTO_STORICO_ENDPOINT, puntiCampionamentoStateConfig),
    PuntiCampionamentoStoricoService,
  ],
  imports: [
    CommonModule,
    PuntiCampionamentoRoutingModule
  ],
})
export class PuntiCampionamentoModule { }
